// extracted by mini-css-extract-plugin
module.exports = {"row":"HouseWithCameraTable_row__1XdVP"};